import { Label, mergeStyles, Stack } from '@fluentui/react';
import dateFormat from 'dateformat';

import shipmentStatuses from '../../../shared/shipment-statuses.json';
import { FormVariables, ShipmentInfo } from '../slice/newFormReducers';

type Props = {
  formVariables: FormVariables & {
    shipment?: ShipmentInfo;
  };
};

const SERVER_TIME_OFFSET = 8 * 60 * 60 * 1000;

export default (props: Props) => {
  const shipmentInfo =
    props.formVariables.shipmentInfo || props.formVariables.shipment;
  const statusInfo = shipmentStatuses.find(
    (s) => s.key === shipmentInfo?.status
  );

  const startTime =
    statusInfo?.selectors?.includes("date-start") &&
    shipmentInfo?.dateStartTimestamp;
  const endTime =
    statusInfo?.selectors?.includes("date-end") &&
    shipmentInfo?.dateEndTimestamp;
  const fixedTime =
    statusInfo?.selectors?.includes("date") && shipmentInfo?.dateTimestamp;

  const parseDate = (t: number) => {
    const d = new Date(t);
    d.setTime(d.getTime() + SERVER_TIME_OFFSET);
    return dateFormat(d, "dd mmmm yyyy dddd")
  };
  const dateString = [fixedTime, startTime, endTime]
    .filter((x) => typeof x === "number")
    .map((x) => parseDate(x as number))
    .join(" ile ");

  return (
    <Stack horizontalAlign="center" className="form-styles">
      <Label>Teslimat Bilgileri:</Label>
      <span className={spanStyles}>
        {statusInfo?.showTitleInPDF && (
          <>
            {statusInfo.text} <br />
          </>
        )}
        {dateString.includes("ile")
          ? dateString + " arasında teslim"
          : dateString}
      </span>
    </Stack>
  );
};

const spanStyles = mergeStyles({
  width: "90%",
  textAlign: "center",
  marginLeft: "5%",
});
